import { Pipe, PipeTransform } from "@angular/core";
import { ITeamChatMessageSegment, TeamChatMentions } from "@models";

/**
 * Splits a chat message into plain runs and @mention runs so the template can colour the mentions.
 *
 * A pipe rather than a component method: pipes are pure, so the split runs once per distinct body
 * instead of on every change detection pass -- a method would hand *ngFor a brand new array each
 * cycle and have it rebuild every message in the thread.
 */
@Pipe({
	name: "chatMentions",
	standalone: false
})
export class ChatMentionsPipe implements PipeTransform {
	transform(body: string): ITeamChatMessageSegment[] {
		return TeamChatMentions.getSegments(body);
	}
}
